import { InputPhone } from 'components/input/InputPhone';
import { InputTitle } from 'components/input/InputTitle';
import { Radio, Row, Select, Spacing, TextInput, Typography } from 'enable-ui';
import { GenderType } from 'enums/gender';

import { SelectStyle } from 'styles/select';

import type { TrainerProfileFormProps } from '../core/type';

export const TrainerProfileForm: React.FC<TrainerProfileFormProps> = ({
  name,
  gender,
  phone,
  level,
  levels,
  isView,
  onChangeLevel,
  handleChangePhone,
  handleChange,
  onChangeGender,
  firstName,
  lastName,
  email,
  emailStatus,
}) => {
  return (
    <Spacing
      spacing="md"
      type="margin"
      placement="top"
      style={{
        width: 800,
      }}
    >
      <Row direction="column">
        <Typography variant="h4" weight={600}>
          Profile
        </Typography>
        <Spacing
          spacing="md"
          placement="top"
          type="margin"
          style={{
            width: '100%',
          }}
        >
          <InputTitle title="Email" />
          <TextInput
            disabled={isView}
            name="email"
            containerStyle={{ maxWidth: 'auto' }}
            value={email}
            onChange={handleChange}
            helperText={emailStatus?.helperText}
            color={emailStatus?.color}
          />
        </Spacing>
        <Row style={{ gap: 16 }}>
          <Spacing
            spacing="md"
            placement="top"
            type="margin"
            style={{
              width: '100%',
            }}
          >
            <InputTitle title="Given name" />
            <TextInput
              disabled={isView}
              name="firstName"
              containerStyle={{ maxWidth: 'auto' }}
              value={firstName}
              onChange={handleChange}
            />
          </Spacing>
          <Spacing
            spacing="md"
            placement="top"
            type="margin"
            style={{
              width: '100%',
            }}
          >
            <InputTitle title="Family name (optional)" />
            <TextInput
              disabled={isView}
              name="lastName"
              containerStyle={{ maxWidth: 'auto' }}
              value={lastName}
              onChange={handleChange}
            />
          </Spacing>
        </Row>
        <Spacing
          spacing="xl"
          placement="top"
          type="margin"
          style={{
            width: '100%',
          }}
        >
          <InputTitle title="Gender" />
          <Row>
            {Object.keys(GenderType).map((key) => {
              const checked = gender.toLowerCase() === key.toLowerCase();

              return (
                <Radio
                  disabled={isView}
                  key={key}
                  checked={checked}
                  onClick={onChangeGender(key)}
                  style={{
                    marginRight: 10,
                  }}
                >
                  {key}
                </Radio>
              );
            })}
          </Row>
        </Spacing>
        <Spacing
          spacing="xl"
          placement="top"
          type="margin"
          style={{
            width: '100%',
          }}
        >
          <InputPhone
            disabled={isView}
            title="Phone number"
            value={phone}
            onChange={handleChangePhone}
          />
        </Spacing>
        <Spacing
          spacing="xl"
          placement="top"
          type="margin"
          style={{
            width: '100%',
          }}
        >
          <InputTitle title="Level" />
          <SelectStyle>
            <Select
              inputStyle={{
                width: '100%',
                backgroundColor: '#ffffff',
              }}
              disabled={isView}
              containerStyle={{ maxWidth: 'none' }}
              options={levels}
              selectedKeys={level}
              onChange={onChangeLevel}
              dropdownConfig={{
                dropdownConfig: {
                  placement: 'bottom-start',
                  offset: [-10, 4],
                },
              }}
            />
          </SelectStyle>
        </Spacing>
      </Row>
    </Spacing>
  );
};
